enum TaxiListingSortKey {
  TAXI_COMPANY_NAME_ASC = "TAXI_COMPANY_NAME_ASC",
  TAXI_COMPANY_NAME_DESC = "TAXI_COMPANY_NAME_DESC",
  TAXI_COMPANY_DISPLAY_NAME_ASC = "TAXI_COMPANY_DISPLAY_NAME_ASC",
  TAXI_COMPANY_DISPLAY_NAME_DESC = "TAXI_COMPANY_DISPLAY_NAME_DESC",
}

export default TaxiListingSortKey;
